import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import React from "react";
import { useSelector } from "react-redux";

export default function Table() {
  const state = useSelector((store) => store.analyze);
  const { fourPLDataPrepared } = state;
  const { rows, columns } = fourPLDataPrepared;

  return (
    <Box sx={{ mt: 3 }}>
      <DataGrid
        rows={rows}
        columns={columns}
        disableColumnMenu
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 20,
            },
          },
        }}
        pageSizeOptions={[20, 50, 100]}
        //slots={{ toolbar: GridToolbar }}
      />
    </Box>
  );
}
